'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactScroll = require('react-scroll');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _HowItWorks = require('./HowItWorks.css');

var _HowItWorks2 = _interopRequireDefault(_HowItWorks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HowItWorks = (_dec = (0, _reactCssModules2.default)(_HowItWorks2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HowItWorks, _Component);

  function HowItWorks() {
    (0, _classCallCheck3.default)(this, HowItWorks);
    return (0, _possibleConstructorReturn3.default)(this, (HowItWorks.__proto__ || (0, _getPrototypeOf2.default)(HowItWorks)).apply(this, arguments));
  }

  (0, _createClass3.default)(HowItWorks, [{
    key: 'render',
    value: function render() {
      var title = 'How it works';
      var description = 'Deforestation Free Funds tracks thousands of mutual funds commonly found in retirement plans.';
      var url = _config2.default.domain + _config2.default.routes.howitworks;

      var sriIcon = require('../../../static/images/sri.png');
      var ussifIcon = require('../../../static/images/ussif-icon.png');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page', id: 'top' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'title-nav-row' },
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 8, styleName: 'title-nav-title' },
              _react2.default.createElement(
                'h1',
                { styleName: 'title' },
                'How it works'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'subtitle' },
                'Getting started, methodology, and deforestation-risk company lists'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'lede' },
                'Deforestation Free Funds sources financial data from Morningstar, an investment research company. We use Morningstar\u2019s mutual fund and stock data to analyze funds and find investments in deforestation-risk companies. Our database covers thousands of the most popular mutual funds, the type of investments most common in retirement plans like employer-offered 401(k)s.'
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Col,
              { xs: 12, sm: 4, styleName: 'title-nav-nav' },
              _react2.default.createElement(
                'nav',
                { styleName: 'page-nav' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'page-nav-title' },
                  'Contents'
                ),
                [['Getting started', 'getting-started'], ['Deforestation-risk companies', 'companies'], ['Mutual fund grades', 'deforestation-grades'],
                // ['Fund managers','fund-manager-ratings'],
                ['Spreadsheet', 'spreadsheet']].map(function (e, i) {
                  return _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      key: 'nav-scroll-link-' + i,
                      to: e[1],
                      spy: true,
                      smooth: true,
                      duration: 500,
                      title: e[0]
                    },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'page-nav-btn' },
                      e[0]
                    )
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'getting-started' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Getting started'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Finding your funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'We source data on companies and mutual funds from financial services provider Morningstar. Our database covers thousands of U.S. open-end mutual funds and exchange-traded funds (ETFs), some of the most common funds held in 401(k)s, 403(b)s, and other retirement plans.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Search for funds by name, ticker, or asset manager. Use the search bar below, or ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    title: 'Search funds',
                    xstrong: true
                  },
                  'use the search page'
                ),
                ' to do more advanced searches, such as filtering funds by investing style or asset manager. When you find a fund you\'re looking for, click it to see the full results.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'search-bar-wrap' },
                _react2.default.createElement(_components.AutocompleteSearch, null)
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'p',
                null,
                'We don\'t have everything in our database \u2014 we only analyze U.S. mutual funds and ETFs that are at least 50% invested in stock holdings, and our data license restricts us to displaying only a few thousand portfolios.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Looking for your favorite fund and can\u2019t find it? With more resources, we could include more funds \u2014 ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.donate,
                    title: 'Donate to As You Sow',
                    xstrong: true
                  },
                  'make a gift today to make a difference.'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-title' },
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                  '\xA0',
                  _react2.default.createElement(
                    'em',
                    null,
                    'Our research universe'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Our database covers open-end mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don\u2019t have data on funds domiciled outside the U.S. The fund ratings are based on tracking stock investments in publicly-traded companies. Currently, we don\u2019t have ratings for fixed income funds. We exclude funds with less than 50% of fund assets in equity holdings from the analysis universe.'
                  )
                )
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null)
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'companies' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Deforestation-risk companies'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'The Deforestation Free Funds list is comprised of 380 publicly listed companies, compiled from independent research as well as from existing resources within the civil society research and investor advocacy communities on forest-risk companies, including ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.fAndf, title: 'Forests & Finance', xstrong: true },
                  'Forests & Finance'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.forest500, title: 'Forest500', xstrong: true },
                  'Forest500'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.cdpForests, title: 'CDP Forests', xstrong: true },
                  'CDP Forests'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.supplychange, title: 'Supply Change.org', xstrong: true },
                  'Supply Change.org'
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.spott, title: 'ZSL SPOTT', xstrong: true },
                  'ZSL SPOTT'
                ),
                '. Every company on the Deforestation Free Funds list may be considered at risk for exposure to tropical deforestation, whether directly through production and trading (Commodity producers and traders); through supply chain links (Major consumer brands); or through financing of producers and traders (Forest-risk banks and lenders). Where a company is a parent or a subsidiary of a privately held company, only the publicly listed company is named.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Most companies on the list were sourced through existing resources within the civil society research and investor advocacy communities, including ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.fAndf, title: 'Forests & Finance', xstrong: true },
                  'Forests & Finance'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.forest500, title: 'Forest500', xstrong: true },
                  'Forest500'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.cdpForests, title: 'CDP Forests', xstrong: true },
                  'CDP Forests'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.supplychange, title: 'Supply Change.org', xstrong: true },
                  'Supply Change.org'
                ),
                ' and ',
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.spott, title: 'ZSL SPOTT', xstrong: true },
                  'ZSL SPOTT'
                ),
                '.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Relative criteria:'
                ),
                ' a significant percentage of company revenues are engaged in that deforestation-risk business sector. An example is Equatorial Palm Oil, which has a significant percentage of company revenues engaged in palm oil production.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Absolute criteria:'
                ),
                ' the percentage of company revenues engaged in that deforestation-risk business sector is not significant, but due to the large size of the company, the total amount of company revenue engaged in that deforestation-risk business sector is significant. An example is Amazon.com, which is a major consumer brand engaged in all six commodity sectors analyzed (palm oil, paper/pulp, rubber, timber, cattle, and soy). While the percentage of Amazon\'s company revenues engaged in these sectors is not significant, the sheer size of Amazon\'s operations makes the total amount of revenue significant.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Policy criteria:'
                ),
                ' the company has no corporate policies to manage and mitigate risk in the deforestation-risk business sectors it\'s engaged in (i.e. does not have a No Deforestation policy, or has gaps in achieving full implementation of said policy).'
              )
            ),
            _react2.default.createElement(_components.ScreenedCompanies, null)
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'deforestation-grades' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Mutual fund grades'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Calculating exposure to deforestation-risk companies'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Mutual funds can have a varying number of holdings, from less than one hundred to several thousand. For each fund, we calculate the total number, dollar amount, and percentage of the fund\u2019s assets that are invested in those companies.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'We only look for direct stock holdings in deforestation-risk companies. That means that holdings that are not stocks, like cash holdings or bonds, are not rated. In the fund\'s investment profile, we show a "Percent Rated" metric, equivalent to the percent of the fund that is invested in stocks. The higher a fund\u2019s Percent Rated value, the more holdings we were able to examine. A fund with a lower Percent Rated value may have hidden deforestation-risk investments that our tool cannot account for, in the form of bond holdings or other asset types.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sidebar' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-title' },
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle', nospace: true }),
                  '\xA0',
                  _react2.default.createElement(
                    'em',
                    null,
                    'Measuring long holdings only'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sidebar-info' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'When calculating a fund\'s exposure to a screen list, we only consider the portfolio\'s long investments, ignoring any shorts or liabilities. The formula for holding weight is ',
                    _react2.default.createElement(
                      'em',
                      null,
                      'holding market value divided by the sum of the market value for all long holdings in the portfolio.'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Deforestation grades'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Based on the fund\'s deforestation exposure, it earns a deforestation grade.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullets' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 1, large: true }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'No holdings flagged for our deforestation screens. Assigned a grade of A.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 2, large: true }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fund is invested in deforestation-risk banks and lenders and/or major consumer brands, but no holdings flagged for our deforestation-risk agricultural commodity producer/trader screen. Assigned a grade of B.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 3, large: true }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fund is invested in deforestation-risk agricultural commodity producer/traders, below the threshold of 0.5%. Assigned a grade of C.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 4, large: true }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 0.5% and below 1.5%. Assigned a grade of D.'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 5, large: true }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    'Fund is invested in deforestation-risk agricultural commodity producer/traders, above the threshold of 1.5%. Assigned a grade of F.'
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'If a fund owns some of the companies we screen for, but has a proven track record of engaging the companies it owns by taking actions such as filing shareholder resolutions on deforestation or similar environmental issues, it earns a special acknowledgement as a \u201Cknown sustainability engager\u201D, instead of a letter grade.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'risk-bullets' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'risk-bullet' },
                  _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'screen-icon-label' },
                    '\u201CKnown sustainability engager\u201D grade. Fund is offered by an asset manager that frequently engages companies it invests in to push for better behavior using the shareholder resolution process.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Details on deforestation exposure'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'Along with the deforestation grade, we show details on the fund portfolio\'s flagged holdings.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The number of flagged holdings, the amount invested by the fund, and the percent of the fund\'s portfolio those holdings make up are shown. The same figures are available for the various sub-categories, and for each individual flagged holding.'
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Sustainable funds'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement('img', {
                styleName: 'sri',
                src: sriIcon,
                alt: 'Sustainably-mandated  fund',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'sri-icons-tooltip',
                'data-place': 'bottom',
                'data-tip': '<div style=\'max-width:200px;\'>Designated a sustainably-mandated fund by Morningstar. Sustainably-mandated funds consider issues like the environment and human rights.</div>'
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'sri-icons-tooltip' }),
              _react2.default.createElement(
                'p',
                null,
                'We use Morningstar\'s "sustainability mandate" indicator to determine which funds are displayed as sustainably-mandated. Sustainably-mandated funds make investment decisions based on issues like environmental responsibility, human rights, or religious views. A sustainably-mandated fund may take a proactive stance by selectively investing in, for example, environmentally-friendly companies, or firms with good employee relations. They may also avoid investing in companies involved in promoting alcohol, tobacco, or firearms, or in the defense industry. Look for this symbol to find funds that are designated sustainably-mandated.'
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'Sustainability engagers'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(_components.Grade, { grade: 1.5, large: true }),
              _react2.default.createElement(
                'p',
                null,
                'If you see this symbol, it means that fund is a known sustainability engager.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Some sustainability-mandated funds actively engage the companies they own. Indeed, efforts by sustainability-focused investors whose funds are found on this site have been crucial to driving positive change in the palm oil sector. A number of fund families are ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'known sustainability engagers'
                ),
                ', and have taken actions such as filing ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.aysvote, title: 'Vote Your Shares | As You Sow' },
                  'shareholder resolutions'
                ),
                ' asking for policy changes. Those families deserve special acknowledgement - often, they are using their investments to make sure they have a voice at the table to call for real improvements in company behavior. We used ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.ceres, title: 'Ceres Shareholder Resolution Database' },
                  'data collected by Ceres'
                ),
                ' to identify fund families that have filed shareholder resolutions on deforestation, climate change, or other environmental issues. If a fund owns companies we screen for, but the family is a known filer of deforestation or environmental-related shareholder resolutions, it earns a special engagement score. ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: '#7', title: 'FAQs | Deforestation Free Funds' },
                  'Read more about our deforestation grades.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Are you a fund manager that has filed a deforestation-related shareholder resolution, or otherwise engage the companies in your portfolio on sustainability issues? ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.contact,
                    title: 'Contact As You Sow',
                    xstrong: true
                  },
                  'Get in touch - we\u2019d love to hear from you.'
                )
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              'The Sustainable Investment Forum'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement('img', {
                styleName: 'ussif',
                src: ussifIcon,
                alt: 'Member of US-SIF, the Forum for Sustainable and Responsible Investment',
                'data-multiline': true,
                'data-effect': 'solid',
                'data-html': true,
                'data-for': 'ussif-icons-tooltip',
                'data-place': 'bottom',
                'data-tip': '<div style=\'max-width:200px;\'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>'
              }),
              _react2.default.createElement(_reactTooltip2.default, { id: 'ussif-icons-tooltip' }),
              _react2.default.createElement(
                'p',
                null,
                'The Forum for Sustainable and Responsible Investment is a group advancing sustainable, responsible, and impact investing. Asset managers who are members of US-SIF often have policies to exclude or restrict investments in companies with high deforestation risk. Look for this symbol to find funds that are members of US-SIF.'
              )
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'answer-title' },
              '#DefundDeforestation toolkit'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'answer-info' },
              _react2.default.createElement(
                'p',
                null,
                'When you\'re done looking up funds and finding the data you need, what\'s next? You can learn how to make a change and move your money with our ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.toolkit,
                    xstrong: true,
                    title: '#DefundDeforestation toolkit'
                  },
                  '#DefundDeforestation toolkit'
                ),
                '. Whether you\u2019re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help. There\'s an in-depth guide to responsible investing, links to external resources, a sample letter to send to your employer 401(k) manager, and more \u2014 everything you need to make a change and get started investing your money deforestation free.'
              )
            ),
            _react2.default.createElement(_components.ScrollToTop, null)
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'methodology-section' },
            _react2.default.createElement('div', { styleName: 'anchor', id: 'spreadsheet' }),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              'Spreadsheet'
            ),
            _react2.default.createElement(_components.Changelog, null),
            _react2.default.createElement(_components.ScrollToTop, null)
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return HowItWorks;
}(_react.Component)) || _class);
exports.default = HowItWorks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/HowItWorks/HowItWorks.js
// module id = 1336
// module chunks = 0